<template>
  <div class="pb-12">
    <v-container 
      fluid
    >
      <h2 class="mb-10 pb-2 title-text" >Certifications</h2>
      <v-row>
        <v-col 
          cols="12"
          class="article"
        >
          <div class="act-detail details">
            <div 
              class="act-item"
              :class="{ 'pl-0 pr-0': $vuetify.display.mobile }"
            >
              <div>
                <h2 class="mb-2">SMETA Audit Report</h2>
                <hr class="title-border">
                <div class="pt-6 pb-4 mb-4 desc">
                  <p>22 October 2024</p>
                </div>
                <v-row>
                  <v-col
                    class="desc-text"
                    :cols="12"
                  >
                    <p class="mb-4">We are pleased to announce that LeachGarner is compliance of Sedex members ethical trade.</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    :cols="$vuetify.display.mobile ? 12:10"
                  >
                    <v-img 
                      :src="require('@/assets/certs/SEDEX Audit Report P1.jpg')"
                      alt="SEDEX Audit Report"
                      width="100%" 
                      height="100%" 
                      contain
                    >
                    </v-img>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>

export default {
  name: "CertDetailOct2024Page",
}
</script>